import $ from 'jquery'

const RegistrationUtil = {
    /**
     * Allows a child's prototype to extend a parent's prototype. When inheriting,
     * a child class should call the parent's constructor like Parent.call(this), where
     * "Parent" is the parent's function/class name. To call a parent's method, use the form:
     * Parent.prototype.methodName.call(this).
     * @param  Function child  Child function (ie: class)
     * @param  Function parent Parent function (ie: class)
     * @param  Object   proto  (Optional) Methods to extend into child class prototype.
     */
    inherit: function(child, parent, proto) {
        var childP = Object.create(parent.prototype)
        childP.constructor = child
        child.prototype = childP

        if (typeof proto !== 'undefined') {
            $.extend(child.prototype, proto)
        }
    },

    softIndexOf: function(array, needle) {
        var len = array.length
        for (var i = 0; i < len; ++i) {
            if (array[i] == needle) return i
        }
        return -1
    },

    ajax: function(opts) {
        opts.data = opts.data || {}

        opts.data['requestid'] = '' + Math.floor(Math.random() * 999999) + '-' + Math.floor(Math.random() * 999999)

        // STRINGIFY DATA
        //opts.data = opts.data ? JSON.stringify(opts.data) : {};

        return $.ajax(opts)
    },

    escape: function(s) {
        return ('' + s) /* Forces the conversion to string. */
            .replace(/&/g, '&amp;') /* This MUST be the 1st replacement. */
            .replace(/'/g, '&apos;') /* The 4 other predefined entities, required. */
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
    },
    unescape: function(s) {
        return ('' + s)
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<')
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
            .replace(/&amp;/g, '&')
    },
}

export default RegistrationUtil
